var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"docHeader",staticClass:"grid-document-header"},[_c('div',{staticClass:"document-logo"},[_c('div',{staticClass:"document-author-logo"},[(_vm.clientLogoPath)?_c('img',{attrs:{"src":_vm.clientLogoPath,"alt":_vm.client.name}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }